module.exports = __webpack_public_path__ + "static/media/encounters.89bed6ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/encounters.jpg
// module id = 562
// module chunks = 0